export default __webpack_public_path__ + "static/media/clap_pullup.9d1bdf34.svg";